import { useEffect, useState } from "react";

export type SupabaseSessionLike = {
  access_token?: string | null;
} | null;

export type SupabaseSessionState = {
  loading: boolean;
  session: SupabaseSessionLike;
};

export default function useSupabaseSession(): SupabaseSessionState {
  const [state, setState] = useState<SupabaseSessionState>({ loading: true, session: null });

  useEffect(() => {
    let alive = true;
    let unsubscribe: (() => void) | null = null;

    async function bootstrap(): Promise<void> {
      try {
        const { getSupabaseClient } = await import("../lib/supabase");
        const supabase = getSupabaseClient();
        const { data } = await supabase.auth.getSession();

        if (!alive) {
          return;
        }

        setState({
          loading: false,
          session: (data?.session as SupabaseSessionLike) ?? null,
        });

        const { data: authSubscription } = supabase.auth.onAuthStateChange((_event, session) => {
          if (!alive) {
            return;
          }

          setState({ loading: false, session: (session as SupabaseSessionLike) ?? null });
        });

        unsubscribe = () => {
          try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (authSubscription as any)?.subscription?.unsubscribe?.();
          } catch {
            // ignore unsubscribe failures
          }
        };
      } catch {
        if (!alive) {
          return;
        }
        setState({ loading: false, session: null });
      }
    }

    void bootstrap();

    return () => {
      alive = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return state;
}
